import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinpune() {



const cardData = {
  keyword: " Swift Dzire On Rent in Pune ",

headingDescription: "Velocity Cab provides easy and affordable Swift Dzire on rent in Pune, offering a reliable and comfortable travel option for solo travelers, couples, small families, and business commuters. Our well‑maintained Swift Dzire cars are air‑conditioned, fuel‑efficient, and ideal for both city travel and outstation trips. Whether you need an hourly rental, full‑day service, airport transfer, or an outstation journey, Velocity Cab offers flexible booking options with transparent pricing and no hidden charges. With professional drivers, prompt service, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for Swift Dzire rental in Pune.",

topPlaces: [

  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a renowned hill station near Pune celebrated for its strawberry farms, breathtaking viewpoints, and pleasant climate. Travelers booking a sedan cab can visit Venna Lake, Arthur’s Seat, Elephant’s Head Point, and Mapro Garden while enjoying scenic mountain roads. It is an excellent destination for families, couples, and nature enthusiasts."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station known for its rolling hills, Table Land, and colonial-era charm. Sedan cab travelers can explore scenic viewpoints, strawberry farms, and lush valleys while enjoying a comfortable outstation journey. The peaceful atmosphere makes it ideal for relaxation, sightseeing, and photography."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a beautifully planned hill city near Pune offering colorful architecture, lakeside views, and adventure activities. Travelers using a sedan cab can enjoy a scenic drive through the Western Ghats, stroll along the waterfront promenade, and indulge in boating, cycling, and nature walks. It is a perfect destination for a refreshing day trip."
  },
    {
    title: "Lonavala",
    description: "Lonavala is one of the most popular hill stations near Pune, known for its lush green valleys, waterfalls, and scenic viewpoints. Travelers booking a sedan cab can enjoy a comfortable drive to explore attractions like Tiger Point, Bhushi Dam, Rajmachi Point, and Karla Caves. The pleasant weather and beautiful landscapes make it an ideal destination for weekend getaways and nature lovers."
  },
  {
    title: "Khandala",
    description: "Khandala is a picturesque hill station located close to Pune, famous for its misty hills, waterfalls, and panoramic viewpoints. Visitors using a sedan cab can enjoy a relaxing journey while exploring Duke’s Nose, Sunset Point, and Rajmachi Fort. The serene surroundings make it perfect for sightseeing, photography, and peaceful retreats."
  },
  {
    title: "Matheran",
    description: "Matheran is India's smallest hill station and is famous for its vehicle-free environment, dense forests, and stunning viewpoints. Sedan cab travelers can drive to Dasturi Point before exploring the hill station on foot or horseback. Popular attractions include Panorama Point, Echo Point, and Charlotte Lake."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination near Pune known for its sandy beaches, sea forts, and relaxed atmosphere. Travelers booking a sedan cab can visit Alibaug Beach, Kolaba Fort, Nagaon Beach, and Varsoli Beach while enjoying a comfortable road trip. It is ideal for beach lovers, families, and weekend vacations."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a revered pilgrimage destination and wildlife sanctuary nestled in the Sahyadri hills. Travelers using a sedan cab can visit the famous Jyotirlinga temple, explore scenic trekking trails, and experience the rich biodiversity of the surrounding forest. The destination is perfect for spiritual seekers and nature lovers."
  },
  {
    title: "Kaas Plateau",
    description: "Kaas Plateau, also known as the Valley of Flowers of Maharashtra, is a UNESCO World Heritage Site famous for its seasonal bloom of colorful wildflowers. Sedan cab travelers can enjoy a scenic drive from Pune to witness the breathtaking floral landscape, making it an unforgettable destination for nature enthusiasts and photographers."
  },
  {
    title: "Raigad Fort",
    description: "Raigad Fort is one of Maharashtra’s most significant historical landmarks and the former capital of Chhatrapati Shivaji Maharaj. Travelers booking a sedan cab can enjoy a scenic drive to the fort, explore its grand gateways, royal palace ruins, and panoramic hilltop views. The destination offers a perfect blend of history, adventure, and breathtaking scenery."
  }
],



services: [
{
name: "Swift Dzire on Rent in Pune",
description: "Swift Dzire on rent in Pune offers one of the most popular and budget-friendly sedan options for both local and outstation travel. Known for its excellent mileage, smooth performance, and comfortable seating, the Dzire is ideal for individuals, couples, and small families. Whether you need a cab for daily commute, airport transfers, or weekend trips, this sedan ensures a cost-effective and comfortable ride. Professional drivers, clean interiors, and air-conditioned vehicles enhance the overall travel experience. With easy booking options and transparent pricing, Swift Dzire remains a top choice for reliable travel in Pune."
},
{
name: "Dzire on Rent for Outstation",
description: "Dzire on rent for outstation travel provides affordable and comfortable long-distance journeys from Pune to destinations like Mumbai, Shirdi, Lonavala, Mahabaleshwar, and Goa. Its fuel efficiency and smooth ride make it ideal for extended travel. Customers can enjoy hassle-free booking with experienced drivers ensuring safe journeys."
},
{
name: "Per Km Rate for Swift Dzire Cab",
description: "Per km rate for Swift Dzire cab in Pune offers transparent pricing based on distance, including tolls and driver allowance. It is one of the most economical options for intercity travel, making it perfect for budget-conscious travelers."
},
{
name: "Dzire per Km Rate for Cab Booking",
description: "Dzire per km rate for cab booking provides clear and affordable pricing for both local and outstation trips. Customers can easily calculate travel costs based on their route and requirements."
},
{
name: "Swift Dzire per Km Rate in Pune",
description: "Swift Dzire per km rate in Pune is designed to offer cost-effective travel solutions with no hidden charges. It is suitable for daily commuting, business travel, and family trips."
},
{
name: "Swift Dzire Rent per Km Rate for Outstation",
description: "Swift Dzire rent per km rate for outstation ensures affordable travel for long-distance journeys with transparent pricing and comfortable rides."
},
{
name: "Swift Dzire Rent per Day",
description: "Swift Dzire rent per day service offers flexible rental options for customers requiring full-day usage. Ideal for city tours, business meetings, and personal travel."
},
{
name: "Swift Dzire Taxi Rate per Km",
description: "Swift Dzire taxi rate per km provides budget-friendly pricing for local and outstation travel with reliable and efficient service."
},
{
name: "Pune to Mahabaleshwar Swift Dzire Tour",
description: "Pune to Mahabaleshwar Swift Dzire tour offers comfortable hill-station travel with smooth driving and scenic routes, ideal for families and couples."
},
{
name: "Pune to Shirdi Swift Dzire Cab",
description: "Pune to Shirdi Swift Dzire cab service provides affordable and comfortable travel for pilgrimage trips with reliable drivers and smooth highway travel."
},
{
name: "Pune to Lonavala Swift Dzire Cab",
description: "Pune to Lonavala Swift Dzire cab offers quick and comfortable travel for weekend getaways with budget-friendly pricing."
},
{
name: "Pune to Ashtavinayak Swift Dzire Cab",
description: "Pune to Ashtavinayak Swift Dzire cab service provides convenient travel for religious tours with comfortable seating and reliable service."
},
{
name: "Pune to Mumbai Airport Swift Dzire Cab",
description: "Pune to Mumbai airport Swift Dzire cab service ensures timely airport transfers with comfortable vehicles and professional drivers."
},
{
name: "Pune to Goa Swift Dzire Hire",
description: "Pune to Goa Swift Dzire hire offers long-distance travel with excellent mileage and comfortable seating for extended journeys."
},
{
name: "Pune to Bhimashankar Swift Dzire Taxi",
description: "Pune to Bhimashankar Swift Dzire taxi provides reliable travel for pilgrimage trips with smooth driving and safe journey."
},
{
name: "Swift Dzire Taxi for Outstation",
description: "Swift Dzire taxi for outstation travel offers economical and comfortable rides for long-distance journeys with professional drivers."
},
{
name: "Swift Dzire Cab for Corporate Employees",
description: "Swift Dzire cab for corporate employees provides reliable and comfortable travel for office commute and business trips."
},
{
name: "Cab Services for Corporate Events",
description: "Cab services for corporate events offer organized transportation solutions for meetings, conferences, and employee travel."
},
{
name: "Velocity Cabs Swift Dzire Service",
description: "Velocity Cabs offers premium Swift Dzire cab services in Pune with reliable vehicles, experienced drivers, and affordable pricing for all travel needs."
},
{
name: "Swift Dzire Rental Pune",
description: "Swift Dzire rental Pune provides flexible travel options for local and outstation journeys with budget-friendly pricing."
},
{
name: "Swift Dzire Cab in Pune",
description: "Swift Dzire cab in Pune offers dependable transportation with comfortable seating and smooth performance."
},
{
name: "Swift Dzire Car Hire Pune",
description: "Swift Dzire car hire Pune provides economical sedan travel for city rides and long-distance journeys."
},
{
name: "Swift Dzire Taxi Service Pune",
description: "Swift Dzire taxi service Pune ensures reliable travel with professional drivers and well-maintained vehicles."
},
{
name: "Book Swift Dzire Cab Pune",
description: "Book Swift Dzire cab Pune easily with online booking, instant confirmation, and transparent pricing for hassle-free travel."
},
{
name: "Swift Dzire Car Rental Pune",
description: "Swift Dzire car rental Pune offers cost-effective travel options with comfortable and well-maintained vehicles."
},
{
name: "Swift Dzire Cab Booking Pune",
description: "Swift Dzire cab booking Pune allows quick and easy reservations with flexible scheduling and reliable service."
},
{
name: "Swift Dzire Sedan Cab Pune",
description: "Swift Dzire sedan cab Pune offers smooth and budget-friendly travel with comfortable seating and efficient performance."
}
],

tableData: [
["Swift Dzire on Rent in Pune","Dzire on Rent for Outstation"],
["Per Km Rate for Swift Dzire Cab","Dzire per Km Rate for Cab Booking"],
["Swift Dzire per Km Rate in Pune","Swift Dzire Rent per Km Rate for Outstation"],
["Swift Dzire Rent per Day","Swift Dzire Taxi Rate per Km"],
["Pune to Mahabaleshwar Swift Dzire Tour","Pune to Shirdi Swift Dzire Cab"],
["Pune to Lonavala Swift Dzire Cab","Pune to Ashtavinayak Swift Dzire Cab"],
["Pune to Mumbai Airport Swift Dzire Cab","Pune to Goa Swift Dzire Hire"],
["Pune to Bhimashankar Swift Dzire Taxi","Swift Dzire Taxi for Outstation"],
["Swift Dzire Cab for Corporate Employees","Cab Services for Corporate Events"],
["Velocity Cabs Swift Dzire Service","Swift Dzire Rental Pune"],
["Swift Dzire Cab in Pune","Swift Dzire Car Hire Pune"],
["Swift Dzire Taxi Service Pune","Book Swift Dzire Cab Pune"],
["Swift Dzire Car Rental Pune","Swift Dzire Cab Booking Pune"],
["Swift Dzire Sedan Cab Pune","Swift Dzire on Rent in Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Affordable Sedan Rental in Pune",
    WhyChoosedescription: "Velocity Cabs offers Swift Dzire on rent in Pune at budget-friendly rates, making it an ideal choice for daily travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are well experienced in Pune city routes and highways, ensuring safe driving, smooth travel, and timely pickups and drop-offs."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Swift Dzire rental in Pune. Customers receive complete fare details including per km charges, toll charges, and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Swift Dzire rental service in Pune operates 24/7. Whether you need an early morning ride or late-night travel, Velocity Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Sanitized AC Vehicles",
    WhyChoosedescription: "All Swift Dzire cars are fully air-conditioned, well maintained, and regularly sanitized to provide a safe and comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Velocity Cabs offers flexible booking options including local packages (8 hours/80 km), outstation travel, one-way trips, and round-trip bookings."
  },
  {
    WhyChooseheading: "Ideal for Daily & Business Travel",
    WhyChoosedescription: "Swift Dzire is perfect for solo travelers, couples, and business trips with comfortable seating for 4 passengers and sufficient luggage space."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Pune",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Swift Dzire on rent in Pune due to professional drivers, clean vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide Swift Dzire on rent in Pune?", answer: "Yes, Velocity Cabs provides Swift Dzire rental services in Pune for local and outstation travel." },
  { question: "What is the price of Swift Dzire on rent in Pune?", answer: "The rental cost typically starts from ₹10 to ₹14 per km or ₹1800 to ₹3000 per day depending on the package." },
  { question: "How many passengers can travel in Swift Dzire?", answer: "Swift Dzire can comfortably accommodate 4 passengers along with luggage." },
  { question: "Is Swift Dzire available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Pune using Swift Dzire vehicles." },
  { question: "Can I book Swift Dzire for outstation trips?", answer: "Yes, Swift Dzire is available for outstation travel from Pune to destinations like Mumbai, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our Swift Dzire rental service in Pune operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Swift Dzire vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book Swift Dzire online?", answer: "Yes, customers can easily book Swift Dzire on rent in Pune online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all rentals include professional drivers for a safe and comfortable journey." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Patil",
    feedback:
      "Swift Dzire on rent in Pune from Velocity Cab was clean, well-maintained, and provided a smooth and comfortable ride throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Sharma",
    feedback:
      "Swift Dzire on rent in Pune with Velocity Cab was a great experience. The vehicle was in excellent condition, and the ride was safe, punctual, and hassle-free.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const puneSwiftDzireJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Swift Dzire On Rent in Pune | Velocity Cabs",
  "description": "Rent a Swift Dzire in Pune with Velocity Cabs for outstation trips, corporate events, airport transfers, and local city travel. Book Swift Dzire per km or per day for comfortable journeys.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": [
    "Swift Dzire Car Rental Pune",
    "Outstation Swift Dzire Cab",
    "Corporate Swift Dzire Hire",
    "Swift Dzire Airport Transfer Pune",
    "Pune to Mahabaleshwar Swift Dzire",
    "Pune to Shirdi Swift Dzire",
    "Pune to Lonavala Swift Dzire",
    "Pune to Ashtavinayak Swift Dzire",
    "Pune to Mumbai Airport Swift Dzire",
    "Pune to Goa Swift Dzire Hire",
    "Pune to Bhimashankar Swift Dzire Cab"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Swift Dzire On Rent in Pune | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book Swift Dzire on rent in Pune with Velocity Cabs. Perfect for outstation trips, corporate events, airport transfers, and local city travel. Swift Dzire per km and per day available."
  />
  <script type="application/ld+json">
    {JSON.stringify(puneSwiftDzireJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinpune;